module.exports = __webpack_public_path__ + "img/TZS09417.1b827a3d.jpeg";